/**
 * Extract year from various timestamp formats
 * @param {string} timestamp - Event timestamp
 * @returns {string} - Year as string
 */
export const getYearFromTimestamp = (timestamp) => {
    if (!timestamp) return new Date().getFullYear().toString();
    
    // Format 1: "Jan 15, 2026"
    const yearMatch = timestamp.match(/\d{4}/);
    if (yearMatch) {
      return yearMatch[0];
    }
    
    // Format 2: ISO string "2025-08-28T09:30:00Z"
    try {
      const date = new Date(timestamp);
      if (!isNaN(date.getTime())) {
        return date.getFullYear().toString();
      }
    } catch (e) {
      console.warn("Could not parse timestamp:", timestamp);
    }
    
    // Fallback to current year
    return new Date().getFullYear().toString();
  };
  